// extracted by mini-css-extract-plugin
module.exports = {"container":"recipeListHeader_container__ZEaso","header":"recipeListHeader_header__o_F8n","title":"recipeListHeader_title__KWbw2","text":"recipeListHeader_text___3P6c"};